export enum SoulEntityType {
  CONTENT = "content",
  ORDER = "order",
}

export enum SoulEntityContentType {
  PUBLICATION = "publication_original",
  VIDEO = "video",
}
